import script from "./AddLicense.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLicense.vue?vue&type=script&setup=true&lang=js"

import "./AddLicense.vue?vue&type=style&index=0&id=87626106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87626106"]])

export default __exports__